// Configuración de la API
export const API_CONFIG = {
  BASE_URL: process.env.VUE_APP_API_URL || 'https://localhost:7209/api/',
  ENDPOINTS: {
    AUTH: {
      LOGIN: '/auth/login',
      PROFILE: '/profile'
    },
    CARRERAS: {
      BASE: '/carreras',
      GET_ALL: '/carreras',
      GET_BY_ID: (id) => `/carreras/${id}`,
      CREATE: '/carreras',
      UPDATE: (id) => `/carreras/${id}`,
      DELETE: (id) => `/carreras/${id}`
    }
  }
}

// Headers por defecto
export const DEFAULT_HEADERS = {
  'Content-Type': 'application/json',
  'Accept': 'application/json'
}

